import React from 'react'
import type { UseFormMethods } from 'react-hook-form'
import styled from 'styled-components'

import { UserDataFormComponentProps } from '../../clickwrap/types'
import CoveredEntityDescription from '../covered-entity/CoveredEntityDescription'
import CoveredEntityRadioButtons from '../covered-entity/CoveredEntityRadioButtons'
import { CoveredEntityFormFieldValues } from '../covered-entity/types'

type UseFormMethodsTyped = UseFormMethods<CoveredEntityFormFieldValues>

export interface CoveredEntityFormProps extends UserDataFormComponentProps {
  className?: string
  control: UseFormMethodsTyped['control']
  errors: UseFormMethodsTyped['errors']
  watch: UseFormMethodsTyped['watch']
}

const CoveredEntityForm: React.FC<CoveredEntityFormProps> = ({
  className,
  control,
  errors,
  disabled,
  watch,
}) => {
  const hipaaCoveredEntityValue = watch('hipaaCoveredEntity')

  return (
    <div className={className}>
      <h2 className="form-title">Are you a Covered Entity under HIPAA?</h2>
      <CoveredEntityDescription />
      <p style={{ fontWeight: `bold` }}>
        Select No if you are unsure. This can be updated later in My Account.
      </p>
      <CoveredEntityRadioButtons
        control={control}
        errors={errors}
        disabled={disabled}
        dataProviderError={undefined}
      />
      {hipaaCoveredEntityValue === 'yes' && (
        <p>
          By selecting Yes, please note you will be required to agree to the terms of our Business
          Associate Agreement. Click Submit below to proceed.
        </p>
      )}
    </div>
  )
}

const StyledCoveredEntityForm = styled(CoveredEntityForm)({
  display: 'flex',
  flexDirection: 'column',

  '.form-title': {
    marginBottom: '20px',
  },
})

export default StyledCoveredEntityForm
